export const API_URL = 'https://atena-poc.herokuapp.com';
// uncomment when developing locally to see logs in console
// export const API_URL = '';

export * from './routes';
export * from './time-delays';
export * from '../pages/inspection/inspection-required-fields';
export * from '../pages/insurance/insurance-required-fields';
